/**
 * @generated SignedSource<<b45a322694bc8971cd331e7842ef8d33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemStoryCardCarouselWidgetDisplayItemArticle$data = {
  readonly images: ReadonlyArray<{
    readonly alt: string | null | undefined;
    readonly isSlideshow: boolean | null | undefined;
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "itemStoryCardCarouselWidgetDisplayItemArticle";
};
export type itemStoryCardCarouselWidgetDisplayItemArticle$key = {
  readonly " $data"?: itemStoryCardCarouselWidgetDisplayItemArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemStoryCardCarouselWidgetDisplayItemArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemStoryCardCarouselWidgetDisplayItemArticle",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": {
              "exclude": null
            }
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "134w_portrait"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"134w_portrait\"})"
        }
      ],
      "storageKey": "images(filter:{\"type\":{\"exclude\":null}})"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "2f41565160f5dab0d38f060392e61ef6";

export default node;
